import ToolkitUtils from '../utils';

export const replaceLeftParen = (str: string) => ToolkitUtils.replaceSpecialSymbols(str, /\(/g, '%28');

export const replaceRightParen = (str: string) => ToolkitUtils.replaceSpecialSymbols(str, /\)/g, '%29');

export const specialCharactersInNamePattern = /%(2[346B]|5E|60|7C)/g;
export const specialCharactersInValuePattern = /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g;
